import React from 'react';
import {
  MapPinIcon,
  HomeModernIcon,
} from '@heroicons/react/24/outline';
import { TWInput, FieldLabel } from '../../../components/ui';
import AddressAutoComplete from '../../../components/address-autocomplete/address-autocomplete';
import RestaurantAutoComplete from '../../../components/restaurant-autocomplete/restaurant-autocomplete';

const Restaurant = ({
  companyname,
  storeaddress,
  errors,
  onChange,
  apartment,
  city,
  state,
  postalcode,
}) => {
  const handleChange = (value, key) => {
    onChange(value, key);
  };

  const onAddressSelect = (obj) => {
    handleChange(obj, 'storeaddress');
  };

  const onRestaurantSelect = (payload) => {
    // payload: { companyname, street, city, state, zipCode, latitude, longitude }
    handleChange(payload, 'companyname');
  };

  return (
    <div className="grid grid-cols-1 gap-3 sm:gap-5">
      <RestaurantAutoComplete
        value={companyname}
        onChange={(text) => handleChange(text, 'companyname')}
        onSelect={onRestaurantSelect}
        error={errors.companyname ? 'Enter your restaurant name' : undefined}
      />

      {/* Street address (wide) + Unit (narrow) on same row */}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-6 sm:gap-4">
        <div className="sm:col-span-4">
          <FieldLabel icon={MapPinIcon} required>
            Street address
          </FieldLabel>
          <div className="[&_input]:h-11 [&_input]:rounded-md [&_input]:border-slate-300 [&_input]:bg-white [&_input]:text-base [&_input]:text-slate-900 [&_input]:placeholder-slate-400 [&_input]:transition focus-within:[&_input]:border-blue-500 focus-within:[&_input]:ring-1 focus-within:[&_input]:ring-blue-500 dark:[&_input]:border-slate-600 dark:[&_input]:bg-slate-900 dark:[&_input]:text-slate-100 dark:focus-within:[&_input]:border-sky-400 dark:focus-within:[&_input]:ring-sky-400">
            <AddressAutoComplete
              value={storeaddress}
              onChange={(e) => onAddressSelect(e)}
            />
          </div>
          {errors.storeaddress && (
            <p className="mt-1 text-xs text-rose-600 dark:text-rose-400">
              Please enter your address.
            </p>
          )}
        </div>
        <div className="sm:col-span-2">
          <TWInput
            label="Unit"
            labelIcon={HomeModernIcon}
            size="lg"
            placeholder="Optional"
            value={apartment}
            onChange={(e) => handleChange(e.target.value, 'apartment')}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-6 sm:gap-4">
        <div className="sm:col-span-3">
          <TWInput
            label="City"
            size="lg"
            placeholder="City"
            value={city}
            onChange={(e) => handleChange(e.target.value, 'city')}
          />
        </div>
        <div className="grid grid-cols-2 gap-3 sm:col-span-3">
          <TWInput
            label="State"
            size="lg"
            placeholder="ST"
            value={state}
            onChange={(e) => handleChange(e.target.value, 'state')}
          />
          <TWInput
            label="Zip"
            size="lg"
            placeholder="00000"
            value={postalcode}
            onChange={(e) => handleChange(e.target.value, 'postalcode')}
          />
        </div>
      </div>
    </div>
  );
};

export default Restaurant;
